package com.iregained.site.region

import com.varabyte.kobweb.core.AppGlobals

// Define the possible regions for your app
enum class Region {
    US, INDIA, CANADA
}

// Create a central "Brain" to hold the active region
object RegionConfig {
    val currentRegion: Region by lazy {
        // Read the variable that Gradle injected during the build!
        val injectedRegion = AppGlobals.getValue("TARGET_REGION")

        // Match the string to our Enum
        when (injectedRegion.uppercase()) {
            "IN" -> Region.INDIA
            "US" -> Region.US
            else -> Region.CANADA
        }
    }
}